import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SetTour, ToursStepsType, ToursType } from './types';

const initialShownTours = {
  dashboard: false,
  appointment: false,
  patients: false,
  report: false,
  addReport: false,
  addDoctorReport: false,
  appointmentDetails: false,
  videoCall: false,
  dicom: false,
  personalReport: false
};

const initialState: ToursType = {
  shownTours: {
    ...initialShownTours
  },
  toursSteps: {
    dashboard: 0,
    appointment: 0,
    patients: 0,
    report: 0,
    addReport: 0,
    addDoctorReport: 0,
    appointmentDetails: 0,
    videoCall: 0,
    dicom: 0,
    personalReport: 0
  }
};

const toursSlice = createSlice({
  name: 'tours',
  initialState,
  reducers: {
    initTours: state => {
      state.shownTours = { ...initialShownTours };
    },
    setTour: (state, action: PayloadAction<SetTour>) => {
      const { key, value } = action.payload;

      if (value) {
        if (state.toursSteps[key] === -1) return;
        Object.keys(state.shownTours).forEach(item => {
          state.shownTours[item] = false;
        });
      }

      state.shownTours[key] = value;
    },

    setTourStep: (state, action: PayloadAction<Partial<ToursStepsType>>) => {
      state.toursSteps = { ...state.toursSteps, ...action.payload };
    },

    setFinishedTours: (state, action: PayloadAction<keyof ToursStepsType>) => {
      state.toursSteps[action.payload] = -1;
    }
  }
});

export const { initTours, setTour, setTourStep, setFinishedTours } =
  toursSlice.actions;
export default toursSlice.reducer;
